var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',_vm._b({staticClass:"support"},'article',_vm.$attrs,false),[_vm._t("top"),_vm._v(" "),_c('div',{staticClass:"grid grid--container support__inner"},[_c('div',{staticClass:"row row--md-h-center"},[_c('div',{class:`col ${_vm.fullWidth ? 'col-lg-12' : 'col--lg-8 col--md-10'}`},[_vm._t("default")],2)])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }